import { Grid } from '@mui/material';
import { isArray } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { VerificationAgencyClientApplicationService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService';
import { SmallLoading } from '../../../Component/Common/Components/Loading/IntermediateLoading';
import { Wizard } from '../../../Component/Common/Components/Wizard/Wizard';
import { ContactsExternalpage } from '../Contacts/ContactsExernalApplicationPage/ContactsExternalpage';
import { CompanyDetailsExternalApplicationPage } from '../Details/companyDetailsExternalApplicationPage';
import { ReferredByExternalPage } from '../Details/ReferredByExternalPage';
import { CommisionerDetailsExternalPage } from './Commisioner/CommisionerExternalPage';
import { FinancialInformationDetailsExternalPage } from './FinancialInformation/FinancialInformationdetailsExternalPage';
import { ServiceRequiredExternalPage } from './ServiceRequired/ServiceRequiredExternalPage';
import { WelcomeScreenExternalApplication } from '../../../Component/Common/Components/ServiceApplication/WelcomeScreenExternalApplication';
import { ClientHeaderBanner } from '../../../Component/Common/Components/ServiceApplication/ClientHeaderBanner';
import { ClientFooterBanner } from '../../../Component/Common/Components/Footer/ClientFooterBanner';
import { SubmittedScreenExternalApplication } from '../../../Component/Common/Components/ServiceApplication/SubmittedScreenExternalApplication';
import { VerificationAgencyClientService } from "../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService";
import { useRecoilState } from "recoil";
import { VerificationCompanyAtom } from "../../../State/VerificationCompany.Atom";
import { ExpiredLinkScreen } from '../../../Component/Common/Components/ExpiredLinkScreen/ExpiredLinkScreen';

export const VerificationAgencyApplicationPageForExternalUse = () => {
    const stepLabels = ['1. Company Details', '2. Contacts', '3. Referred by', '4. Service Required', '5. Financial Information', '6. BEE Commisioner & Other'];
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [isTokenAuthorised, setIsTokenAuthorised] = React.useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);
    const [handleNextCount, setHandleNextCount] = React.useState<number>(-1);
    const [proceed, setProceed] = React.useState<boolean>(true);
    const token = useParams<any>();
    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    const [verificationAgencyBanner, setVerificationAgencyBanner] = useState<string>('');

    const handleSetNextStep = (i: number) => {
        setHandleNextCount(i);
    }

    const handleProceed = (i: boolean) => {
        setProceed(i);
    }

    const TokenAuthorised = async () => {
        const response = await VerificationAgencyClientApplicationService.IsTokenActive(token.token.toString());
        setIsTokenAuthorised(response.data);
        setIsLoading(false);
    }

    const SubmitApplication = async () => {
        setIsLoading(true);
        try {
            const response = await VerificationAgencyClientApplicationService.SubmitExternalApplication(token.token.toString());
            setIsSubmitted(true);
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        } finally {
            setIsLoading(false);
        }
    }

    const getCompanyDetails = async () => {
        if (token.token.toString() !== null && isTokenAuthorised) {
            try {
                const response = await VerificationAgencyClientService.GetCompanyDetailsForExternalApplication(token.token.toString());
                setCompany({ ...company, ...response.data, applicationId: 0, company: response.data.companyName, verificationAgency: response.data.verificationAgencyName });
                setVerificationAgencyBanner(response.data.verificationAgencyBanner);
            } catch (error) {
                console.log(error);
            }
        }
    }

    const CompanyDetailsStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <CompanyDetailsExternalApplicationPage handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} token={token.token.toString()} />
                </Grid>
            </Grid>
        </>
    );

    const ContactsStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <ContactsExternalpage token={token.token.toString()} handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} />
                </Grid>
            </Grid>
        </>
    );

    const ReferredByStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <ReferredByExternalPage token={token.token.toString()} handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} />
                </Grid>
            </Grid>
        </>
    );

    const RequiredServicesStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <ServiceRequiredExternalPage token={token.token.toString()} handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} />
                </Grid>
            </Grid>
        </>
    );

    const FinancialDetailsStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <FinancialInformationDetailsExternalPage token={token.token.toString()} handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} />
                </Grid>
            </Grid>
        </>
    );

    const CommisionerStep = () => (
        <>
            <Grid container mt={1}>
                <Grid item xs={12}>
                    <CommisionerDetailsExternalPage token={token.token.toString()} handleNextCount={handleNextCount} setHandleNextCount={handleSetNextStep} submitForm={SubmitApplication} />
                </Grid>
            </Grid>
        </>
    );

    const wizardSteps = [
        CompanyDetailsStep(),
        ContactsStep(),
        ReferredByStep(),
        RequiredServicesStep(),
        FinancialDetailsStep(),
        CommisionerStep()
    ];

    useEffect(() => {
        TokenAuthorised();
        getCompanyDetails();
    }, [isTokenAuthorised])

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            {verificationAgencyBanner
                && <ClientHeaderBanner banner={verificationAgencyBanner} />
            }

            {!isTokenAuthorised && (
                <ExpiredLinkScreen subText1='Sorry, the verification application form link has expired.'
                    subText2='Please contact your Verification Agency and request a new application form link.' />
            )}

            {isTokenAuthorised && proceed && (
                <WelcomeScreenExternalApplication setHandleProceed={handleProceed} />
            )}

            <div style={{
                flexGrow: 1
            }}>
                {!proceed && (
                    <Grid container justifyContent="center">
                        <Grid item xs={11} mt={3}>
                            {!isSubmitted && !isLoading && isTokenAuthorised && (
                                <Wizard
                                    key={'ApplicationWizard'}
                                    handleNext={true}
                                    handleNextCount={handleNextCount}
                                    stepLabels={stepLabels}
                                    steps={wizardSteps}
                                    lastStepActionLabel={'Submit Application'}
                                    lastStepAction={SubmitApplication}
                                />
                            )}
                            {isLoading && <SmallLoading />}
                            {isSubmitted && !isLoading && (
                                <SubmittedScreenExternalApplication />
                            )}
                        </Grid>
                    </Grid>
                )}
            </div>

            <ClientFooterBanner />
        </div>
    );
}


